var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7744 12.5454L9.30971 1.43773C9.0284 0.954672 8.54246 0.666672 8.00985 0.666672C7.47724 0.666672 6.99195 0.954672 6.71065 1.43773L0.245335 12.5454C-0.0712982 13.0893 -0.0679652 13.7641 0.252667 14.3067C0.533304 14.7819 1.01659 15.0667 1.5452 15.0667H14.4752C15.0031 15.0667 15.4864 14.7819 15.7677 14.3067C16.0883 13.7641 16.091 13.0893 15.7744 12.5454ZM7.34318 9.1755H8.67637V5.24823H7.34318V9.1755ZM7.01015 11.4664C7.01015 10.9238 7.45744 10.4846 8.01005 10.4846C8.56265 10.4846 9.00994 10.9238 9.00994 11.4664C9.00994 12.009 8.56265 12.4482 8.01005 12.4482C7.45744 12.4482 7.01015 12.009 7.01015 11.4664Z",
    fill: "#EDA51F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d30f98176c5d2adcba65437344189f88.svg";
export { ForwardRef as ReactComponent };